"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageType = /** @class */ (function () {
    function MessageType() {
    }
    MessageType.UserMessage = "UserMessage";
    MessageType.SwiftCard = "SwiftCard";
    MessageType.Typing = "Control/Typing";
    MessageType.ClearTyping = "Control/ClearTyping";
    MessageType.LiveState = "Control/LiveState";
    return MessageType;
}());
exports.default = MessageType;
//# sourceMappingURL=MessageType.js.map